import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbTipoCredencial extends AppService {
  abstract prefixo: string;
  abstract getAllTipoCredenciais();
  abstract getAllTipoCredenciaisPromise();
  abstract getAllColeta();
  abstract getAllNaoColeta(): Observable<any>
}